<template>
  <div class="cameras">
      <v-container>

          <v-layout column wrap justify-start> <!-- Holds everything || Root -->

            <v-flex xs12 md6>
                <span class="display-2">Cameras </span>
                <span class="headline font-weight-light">the beauty of the roads</span>
            </v-flex>

            <v-flex xs12>
                
                <v-layout justify-start row wrap>

                    <v-flex xs12 md4>

                        <v-text-field label="Search" prepend-icon="image_search" v-model="search"></v-text-field>

                    </v-flex>

                    <v-flex xs4 md1 v-for="items in filter" :key="items.streetName">
                        <v-btn class="green lighten-3">{{items.streetName}}</v-btn>
                    </v-flex>

                </v-layout>

            </v-flex>

            <v-flex xs6 md3>
                <v-divider></v-divider>
            </v-flex>

            <v-flex>

                <v-layout row wrap justify-center>

                    <v-flex xs12 md3 v-for="cam in allCams" :key="cam.Name">

                        <v-card flat class="text-xs-center ma-2">

                            <v-responsive class="pt-0">
                                <v-img :src="cam.FullImageURL" :aspect-ratio="4/3" height="100%"> </v-img>
                            </v-responsive>

                            <v-card-text>
                            <div class="subheading">{{cam.Name}}</div>
                            </v-card-text>

                        </v-card>

                    </v-flex>

                </v-layout>

            </v-flex>

          </v-layout>

      </v-container>
  </div>
</template>

<script>
const cameras = require('@/assets/cameras/rootCamera.json');
export default {
  name: 'CameraPage',
  mounted () {
  },
  data () {
      return {
          search: '',
          allCams: cameras.Camera,
          searchCams: [], //things that will be 
          filter: [
              {streetName:'H1'},
              {streetName:'H2'},
              {streetName:'H3'}
          ],
      }
  },
  methods: {
  },
  watch: {

      search: function(content) {
          this.searchCams = this.allCams.filter(data => {
              return data.Name.indexOf(content) > 0;
          });
      }

  }
}
</script>